import type { Application } from "@/utils/types/flavor";

export const APPLICATIONS: Application[] = [
  { id: "csd",     label: "CSD",                 subtitle: "Carbonated soft drink" },
  { id: "cold",    label: "Cold beverage",       subtitle: "RTD tea, juice, functional" },
  { id: "hot",     label: "Hot beverage",        subtitle: "Coffee, hot cocoa, tea latte" },
  { id: "dairy",   label: "Dairy",               subtitle: "Milk, yogurt, oat milk" },
  { id: "ice",     label: "Ice cream",           subtitle: "Ice cream, gelato, sorbet" },
  { id: "bake",    label: "Bakery",              subtitle: "Cake, biscuit, pastry" },
  { id: "conf",    label: "Confectionery",       subtitle: "Gummy, hard candy, marshmallow" },
  { id: "sauce",   label: "Sauce / powder",      subtitle: "Liquid or powdered sauces" },
  { id: "snack",   label: "Snack seasoning",     subtitle: "Chips, crackers, popcorn" },
  { id: "alc",     label: "Alcoholic beverage",  subtitle: "Beer, spirits, RTD cocktails" },
  { id: "nutra",   label: "Nutraceutical",       subtitle: "Protein shakes, meal replacement" },
  { id: "pharma",  label: "Oral pharma",         subtitle: "Syrups, chewables, lozenges" },
  { id: "pet",     label: "Pet food",            subtitle: "Kibble coating, wet food, treats" },
  { id: "savory",  label: "Savory / soup",       subtitle: "Broth, instant soup, bouillon" },
  { id: "meat",    label: "Meat & alt-meat",     subtitle: "Marinade, cured, plant-based" },
  { id: "chew",    label: "Chewing gum",         subtitle: "Stick, pellet, bubblegum" },
  { id: "tobacco", label: "Tobacco / vape",      subtitle: "E-liquid, heat-not-burn" },
  { id: "oral",    label: "Oral care",           subtitle: "Toothpaste, mouthwash, rinse" },
];
